<template>
    <span>
        <div v-if="hasFinishedLoadingData">
            <multiselect
                v-model="selection"
                :options="advertisers"
                :multiple="false"
                :customLabel="makeCustomLabel"
                track-by="id"
                placeholder="Select"
                :close-on-select="true"
                :searchable="true"
                label="customLabel"
                :value="advertiser"
            >
            </multiselect>
        </div>
        <div v-else>Loading advertisers...</div>
    </span>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import store from './store.js'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name:  'advertiser-selector',
        store: store,

        props: [],

        data() {
            return {
                selection: this.advertiser
            }
        },

        computed: {
            advertiser() {
                if (_.isEmpty(this.$store.getters.advertiser)) {
                    return {
                        customLabel: ''
                    }
                }

                return this.decorateAdvertiserWithCustomLabel(this.$store.getters.advertiser)
            },

            advertisers() {
                return _.map(this.$store.getters.advertisers, this.decorateAdvertiserWithCustomLabel.bind(this))
            },

            hasFinishedLoadingData() {
                return this.$store.getters.loadingAdvertisers === false && this.$store.getters.loadingSessionAdvertiser === false
            },
        },

        watch: {
            advertiser() {
                this.selection = this.advertiser  // controls pre-selection of advertiser selector
            },

            selection() {
                this.$emit('selection', this.selection)
            }
        },

        methods: {
            makeCustomLabel(advertiser) {
                return `${advertiser.name} (${advertiser.id})`
            },

            decorateAdvertiserWithCustomLabel(advertiser) {
                advertiser.customLabel = this.makeCustomLabel(advertiser)

                return advertiser
            }
        },

        components: {
            Multiselect
        }
    }
</script>
